module.exports = __webpack_public_path__ + "img/login-left.b4458083.png";